/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListAwsIamCredentialsSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListAwsIamCredentialsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListAwsIamCredentialsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListAwsIamCredentialsSecurity$outboundSchema: z.ZodMiniType<
  ListAwsIamCredentialsSecurity$Outbound,
  ListAwsIamCredentialsSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listAwsIamCredentialsSecurityToJSON(
  listAwsIamCredentialsSecurity: ListAwsIamCredentialsSecurity,
): string {
  return JSON.stringify(
    ListAwsIamCredentialsSecurity$outboundSchema.parse(
      listAwsIamCredentialsSecurity,
    ),
  );
}

/** @internal */
export type ListAwsIamCredentialsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListAwsIamCredentialsRequest$outboundSchema: z.ZodMiniType<
  ListAwsIamCredentialsRequest$Outbound,
  ListAwsIamCredentialsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function listAwsIamCredentialsRequestToJSON(
  listAwsIamCredentialsRequest: ListAwsIamCredentialsRequest,
): string {
  return JSON.stringify(
    ListAwsIamCredentialsRequest$outboundSchema.parse(
      listAwsIamCredentialsRequest,
    ),
  );
}
